import type { LaboratoryTestResult } from 'chaika-frontend-types/frontend-cms';

import { LaboratoryTestList } from '@store/models/SystemFields/LaboratoryTest';
import { AbstractField } from './AbstractField';

export class LaboratoryTestField extends AbstractField<LaboratoryTestList, LaboratoryTestResult[]> {
    public makeUpdateParams(): LaboratoryTestResult[] {
        return this.fieldValue.serialize();
    }

    protected setFieldValue(value: LaboratoryTestResult[]): void {
        this.fieldValue = new LaboratoryTestList(value);
    }
}
